
import { Injectable } from '@angular/core';
//import { ScheduleJob } from './schedulejob';
// import { Customer } from './../customers/customers';
import { Observable, throwError, of, Subject, BehaviorSubject } from 'rxjs';
import { retry, catchError, map, finalize, tap } from 'rxjs/operators';
import { HttpClient, HttpHeaders } from '@angular/common/http';
// import { Subdivision } from '../subdivisions/subdivision';

import { environment } from '../../environments/environment';
import { MessagerComponent } from '../messager/messager/messager.component';


@Injectable({
  providedIn: 'root'
})

export class HeatMapService {

constructor(private http: HttpClient){}

baseUrl = environment.baseUrl;

getHeatmapData(): Observable<any> {
    return this.http.get(this.baseUrl + '/rhAPI/jobEntry/heatmapData');
}


init() {}


}